"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used to parse store availability data for NWP.
 */
var NwpStoreItemParser = /*#__PURE__*/function () {
  function NwpStoreItemParser() {
    _classCallCheck(this, NwpStoreItemParser);
  }

  _createClass(NwpStoreItemParser, null, [{
    key: "parse",

    /**
     * Parses availability data.
     *
     * @param {Object} data Data to parse.
     * @return {Object|Null} Parsed data.
     */
    value: function parse(data) {
      var storeItem = data.StoreItem;

      if (storeItem) {
        return {
          ID: String(storeItem.ItemNo.$),
          Type: storeItem.ItemType.$,
          SalesMethodCode: storeItem.SalesMethodCode.$,
          InStockProbabilityCode: this._getStockProbabilityCode(storeItem.Availability),
          SalesLocation: this._getSalesLocation(storeItem.SalesMethodCode.$, storeItem.RecommendedSalesLocation)
        };
      }

      return null;
    }
    /**
     * Returns in stock probability code.
     *
     * @param {Object} availability Availability data.
     * @return {String} Stock probability code.
     */

  }, {
    key: "_getStockProbabilityCode",
    value: function _getStockProbabilityCode(availability) {
      var availableStock = availability.AvailableStockList.AvailableStock;

      if (availableStock.constructor === Array) {
        for (var stockItem in availableStock) {
          if (stockItem.AvailableStockType.$ === 'STORE') {
            return stockItem.InStockProbabilityCode ? stockItem.InStockProbabilityCode.$ : null;
          }
        }
      } else {
        return availableStock.InStockProbabilityCode ? availableStock.InStockProbabilityCode.$ : null;
      }
    }
    /**
     * Returns sales location.
     *
     * @param {String} salesMethodCode Sales method code.
     * @param {Object} location Location object.
     * @return {Object} Sales location data.
     */

  }, {
    key: "_getSalesLocation",
    value: function _getSalesLocation(salesMethodCode, location) {
      if (salesMethodCode == 'SATELLITE' && location.Department) {
        return {
          Department: location.Department.$
        };
      } else if (salesMethodCode == 'SELF_SERVE' && location.Aisle && location.Bin) {
        return {
          Aisle: String(location.Aisle.$),
          Bin: String(location.Bin.$)
        };
      } // FULL_SERVE, DDS or no useful SalesLocation values - contact co-worker


      return null;
    }
  }]);

  return NwpStoreItemParser;
}();

exports.default = NwpStoreItemParser;